import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Globe2 } from "lucide-react";
import api from "../lib/api";
import { Spinner } from "../components/common";
import { chipTint } from "../lib/chipTints";
import TranslateAndListen from "../components/TranslateAndListen";
import TripAutoHero from "../components/TripAutoHero";

/* City Guides hub — every country/region city directory in one place. */
export default function CityGuidesHub() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    document.title = "City Guides by Country | TravelerPulse";
    api.get("/geo/city-directory-index").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="city-guides-hub-page">
      <div className="relative border-b border-zinc-200 overflow-hidden">
        <TripAutoHero query="world cities skyline travel" alt="World cities" className="absolute inset-0 w-full h-full" testid="city-guides-hub-hero" />
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-900/85 via-indigo-900/70 to-sky-700/55" />
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 py-14">
          <p className="text-xs font-mono uppercase tracking-widest text-white/80">TravelerPulse · Geographic Database</p>
          <h1 className="mt-2 font-heading font-900 text-4xl sm:text-5xl tracking-tight text-white">City Guides by Country</h1>
          <p className="mt-3 text-base text-white/90 max-w-3xl">Region-by-region city directories — every place links to its full AI travel guide with Overview, Getting There, Things to See &amp; Do, Food &amp; Drink, Safety and more.</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-5 lg:px-8 py-10">
        <div className="flex justify-end mb-4">
          <TranslateAndListen />
        </div>
        {!items ? <Spinner /> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.map((d, i) => (
              <Link key={d.key} to={d.to} data-testid={`city-guides-hub-${d.key}`}
                style={{ background: chipTint(i) }}
                className="flex items-center justify-between gap-3 border border-zinc-200 px-4 py-4 hover:border-[#1a73e8] transition-colors group">
                <span className="flex items-center gap-2.5 text-sm font-700 text-zinc-800 group-hover:text-[#1a73e8]">
                  <span className="text-xl leading-none">{d.flag || <Globe2 className="w-5 h-5" />}</span>
                  {d.title}
                </span>
                <ChevronRight className="w-4 h-4 shrink-0 text-zinc-400 group-hover:text-[#1a73e8]" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
